import React, { useState, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Avatar from '@material-ui/core/Avatar';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import PersonAdd from '@material-ui/icons/PersonAdd';
import Settings from '@material-ui/icons/Settings';
import { connect } from 'react-redux';
import { signin, reset } from "../redux/action/login.action";

function MenuMember({ history, loginStatus, clearState, custInfo }) {
    const custName = custInfo.map((item) => item.fName);
        
    const handleLogout = () => {
        // loginStatus(false);
        clearState();
        history.push('/');        
    };

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <div>
            <Fragment style={{ float: 'right' }}>
                <Box sx={{ alignItems: 'right', textAlign: 'right' }}>
                    <span style={{ textAlign: "right", color: "#fff" }}>Welcome {custName} &nbsp;&nbsp;&nbsp;</span>
                    {/* <Typography sx={{ minWidth: 100 }}>Contact</Typography>
                            <Typography sx={{ minWidth: 100 }}>Profile</Typography> */}
                    <Tooltip>
                        <IconButton onClick={handleClick} size="small" sx={{ ml: 2 }}>
                            <Avatar sx={{ width: 32, height: 32 }}><i class="fa fa-bars" aria-hidden="true"></i></Avatar>
                        </IconButton>
                    </Tooltip>
                </Box>
                <Menu
                    anchorEl={anchorEl}
                    style={{ Top: "0", fontSize: '20px' }}
                    open={open}
                    size={30}
                    onClose={handleClose}
                    onClick={handleClose}
                    PaperProps={{
                        elevation: 0,
                    }}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                    <MenuItem>
                        <Link style={{ fontSize: '12px' }} to="/member/pet-profile">Pet Profile</Link>
                    </MenuItem>
                    <MenuItem>
                        <Link style={{ fontSize: '12px' }} to="/member/update-profile">My Profile</Link>
                    </MenuItem>
                    <MenuItem>
                        <Link style={{ fontSize: '12px' }} to="/member/call-history">Call History</Link>
                    </MenuItem>
                    <MenuItem>
                        <Link style={{ fontSize: '12px' }} to="/member/transaction-history">Transaction History</Link>
                    </MenuItem>                    
                    <MenuItem>
                        <Link style={{ fontSize: '12px' }} to="/member/change-password">Change Password</Link>                        
                    </MenuItem>                    
                    <Divider />
                    <MenuItem>
                        <button className="btn" style={{ fontSize: '12px', padding: '10px 15px' }} onClick={handleLogout}>
                            <i class="fa fa-sign-out" style={{ color: "#f19f1f" }} aria-hidden="true"></i> &nbsp;&nbsp;&nbsp; Logout
                        </button>
                    </MenuItem>
                </Menu>
            </Fragment>
        </div>
    )
}

const mapDispatchToProps = dispatch => ({
    // loginStatus: (IsLogin) => dispatch(signin(IsLogin)),
    clearState: () => dispatch(reset())    
})

const mapStateToProps = ({ login: { custInfo } }) => ({
    custInfo
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MenuMember));